var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 697.7 556",
    enableBackground: "new 0 0 697.7 556",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M182.4,0.2c-65.5,0-104.3,0.3-116.5,0.9C53.3,1.7,44.2,3.6,38.6,6.9C8.4,26.2,1.8,36.8,1.4,81.2 C3.1,181-5.8,467.1,7.2,521.3c6,12.5,29.4,28.2,44.5,31.4c-6.4,1.6,184.7,3.9,232.4,2.9v0.3c152.1,0.1,291,0.4,361.7-2.9 c15.1-3.5,38.6-18.9,44.7-31.7c2.3-5,4-14.2,4.9-27.6c-1.5-15.5,8.4-271.2-4.1-347.4c-11.5-24.7-27.9-39.1-57.8-40.7 c-20.9-5-239.3,5.1-252.7-14.5c-7.3-11.1-16.2-45.6-20.3-51.1C325.7-17.3,286.6,5.5,182.4,0.2 M319.8,79.5 c5.2,14.5,7.5,22.2,6.7,22.9c12.7,1.1-286.2,2.4-273.6,1.2c-1.4,1.1-1.6-39.3-0.3-40.4c10.2-18.4,53.1-9.3,128.4-12.2 c77.7,0,119.1,1.1,124.3,3.2C309.9,56.6,314.8,65,319.8,79.5 M346.5,155.6c79.5,1,221.3-2.2,289,4.1c11,5.6,6.2,19.5,7.8,43.6 c5.9,67,2,226.4,2,265.8c-2.5,39.9-4,33.7-43.9,35.4c-88-0.9-218.2,0.4-366.9-0.3c-71.8,0-118,0.1-138.6,0.3 c-20.6,0.2-32.9-1.2-36.9-4.1c-4-2.9-6.4-13.4-7-31.4c-1.8-12.6-0.2-130.8-0.9-185.3c0.1-54.8,0.4-87.8,0.9-99.1 c0.6-14.1,2.4-22.3,5.5-24.4C119.8,151.5,227.7,157.6,346.5,155.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder_icon.ff85c17a.svg";
export { ForwardRef as ReactComponent };